module.exports = __webpack_public_path__ + "img/error-500.d130d5d2.png";